import { combineReducers } from 'redux';
import { value } from './value';
import { options } from './options';

export const drawerSystems = combineReducers( {
  value,
  options
} );
